<template>
    <div class="d-flex flex-row card p-3" style="gap: 10px;">
        <div v-if="loading">
            loading...
        </div>
        <div v-if="!loading" class="w-50 card p-3">
            <span style="font-size: 20px;">SEO-Keywords</span>
            <div class="d-flex flex-column" style="gap: 10px">
                <span class="my-2 text-danger text-center" style="font-size: 14px;">* Click on the links to edit *</span>
                <div class="d-flex flex-row available_seo align-items-center px-3" v-for="(item, item_index) in seo_data_list" :key="item_index">
                    <span class="d-flex flex-row align-items-center p-3 w-100">
                        <i class="fa fa-link mr-2"></i>
                        <span>{{ item.page_url }}</span>
                    </span>
                    <div class="d-flex" style="width: 25%; justify-content: space-evenly;">
                        <i @click.prevent="editSeoData(item)" class="fa fa-pencil text-warning"></i>
                        <i @click.prevent="copySeoData(item)" class="fa fa-copy text-primary"></i>
                        <i @click.prevent="deleteSeoData(item)" class="fa fa-trash text-danger"></i>
                    </div>
                    <!-- <i class="fa fa-trash p-3 text-danger" style="cursor: pointer;"></i> -->
                </div>
            </div>
        </div>
        <div v-if="!loading" class="w-50 d-flex flex-column card px-5 p-3" style="gap: 10px">
            <div class="d-flex flex-column">
                <span class="mb-2" style="font-size: 14px;">Page URL:</span>
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-link"></i>
                    </span>
                    <input type="text" class="form-control" v-model="page_url" placeholder="Page URL" aria-label="Page URL" aria-describedby="basic-addon1">
                </div>
            </div>
            <div class="d-flex flex-column">
                <span class="mb-2" style="font-size: 14px;">Meta Title:</span>
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-link"></i>
                    </span>
                    <input type="text" class="form-control" v-model="meta_title" placeholder="Meta Title" aria-label="Meta Title" aria-describedby="basic-addon1">
                </div>
            </div>
            <div class="d-flex flex-column">
                <span class="mb-2" style="font-size: 14px;">Meta Description:</span>
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-link"></i>
                    </span>
                    <textarea class="form-control" v-model="meta_description" aria-label="With textarea" placeholder="Meta Description"></textarea>
                </div>
            </div>
            <div class="d-flex flex-column">
                <span class="mb-2" style="font-size: 14px;">Meta Keywords:</span>
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-link"></i>
                    </span>
                    <textarea class="form-control" v-model="meta_keywords" aria-label="With textarea" placeholder="Meta Keywords"></textarea>
                </div>
            </div>
            <div class="d-flex flex-column">
                <span class="mb-2" style="font-size: 14px;">Meta Author:</span>
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-user"></i>
                    </span>
                    <input type="text" class="form-control" v-model="meta_author" placeholder="Meta Author" aria-label="Meta Author" aria-describedby="basic-addon1">
                </div>
            </div>
            <div class="d-flex flex-row justify-content-center" style="gap: 10px;">
                <button class="btn btn-success" @click.prevent="saveSeoData"><i class="fa fa-save mr-2"></i>Save</button>
                <button class="btn btn-danger" @click.prevent="reset_data"><i class="fa fa-times mr-2"></i>Reset</button>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';

export default {
    data() {
        return {
            edit_id: null,
            page_url: null,
            meta_title: null,
            meta_description: null,
            meta_keywords: null,
            meta_author: null,
            seo_data_list: [],
        }
    },
    async mounted() {
        await this.fetchSeoData()
    },
    methods: {
        reset_data() {
            this.edit_id = null
            this.page_url = null
            this.meta_title = null
            this.meta_description = null
            this.meta_keywords = null
            this.meta_author = null
        },
        async fetchSeoData() {
            const response = await axios.get(`${this.$root.URL_ROOT}updatedApiForProducts.php?type=fetch_seo_data`)
            this.seo_data_list = response.data.data
        },
        deleteSeoData(data) {
            try {
                var ev = this;
                var param = {
                    seo_id: data.id,
                    type: 'delet_seo_data'
                }
                this.$swal({
                    title: "Delete this ?",
                    text: "Are you sure? You won't be able to revert this!",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: "#f00",
                    confirmButtonText: "Yes, Delete it!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios({
                            method: 'POST',
                            url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                            data: param
                        }).then(function (response) {
                            var data = response.data;
                            console.log(data);
                            ev.$swal({
                                toast: true,
                                position: 'top-end',
                                timer: 3000,
                                icon: 'success',
                                timerProgressBar: true,
                                title: 'Action perform successfully'
                            })
                            ev.fetchSeoData()
                        })
                    }
                })
            } catch (error) {
                console.log(error);
            }
        },
        editSeoData(data) {
            this.edit_id = data.id
            this.page_url = data.page_url
            this.meta_title = data.meta_title
            this.meta_author = data.meta_author
            this.meta_description = data.meta_description
            this.meta_keywords = data.meta_keywords
        },
        copySeoData(data) {
            this.page_url = null
            this.meta_title = data.meta_title
            this.meta_author = data.meta_author
            this.meta_description = data.meta_description
            this.meta_keywords = data.meta_keywords
        },
        async saveSeoData() {
            if (!this.page_url || !this.meta_title || !this.meta_description || !this.meta_keywords || !this.meta_author) {
                this.$toasted.global.error({
                    message: "Fill the form to save."
                })
                return
            }
            const data = this.edit_id ? {
                seo_data_id: this.edit_id,
                page_url: this.page_url,
                meta_title: this.meta_title,
                meta_author: this.meta_author,
                meta_description: this.meta_description,
                meta_keywords: this.meta_keywords
            } : {
                page_url: this.page_url,
                meta_title: this.meta_title,
                meta_author: this.meta_author,
                meta_description: this.meta_description,
                meta_keywords: this.meta_keywords
            }
            const response = await axios({
                method: 'POST',
                url: `${this.$root.URL_ROOT}updatedApiForProducts.php?type=save_seo_data`,
                data
            })
            this.$swal({
                toast: true,
                position: 'top-end',
                timer: 3000,
                icon: 'success',
                timerProgressBar: true,
                title: 'Action perform successfully'
            })
            this.reset_data()
            this.fetchSeoData()
        },
    }
}
</script>

<style>
.available_seo {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    border-radius: 10px;
}
.available_seo:hover {
    background: rgb(240, 240, 240);
}
</style>